import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { PRODUCTS_SERVICE_URL } from 'src/app/injection-tokens';
import { map, switchMap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Stats } from '../suppliers/supplier';
import { INDISpecial } from './indi-special';

export interface INDICombinedData {
  specials: INDISpecial[];
  stats: Stats;
}

@Injectable({
  providedIn: 'root',
})
export class INDISpecialsService {
  readonly serviceURL: string;

  constructor(
    @Inject(PRODUCTS_SERVICE_URL) readonly baseServiceURL: string,
    readonly http: HttpClient
  ) {
    this.serviceURL = baseServiceURL + '/specials';
  }

  getCombinedData(): Observable<INDICombinedData> {
    // Sequential on purpose: Firefox aborts parallel requests to the VPN-only API hosts,
    // see "Parallel requests to private API hosts" in AGENTS.md.
    return this.getINDISpecials().pipe(
      switchMap(specials => this.getINDIStats().pipe(map(stats => ({ specials, stats }))))
    );
  }

  createINDISpecial(indiSpecial: INDISpecial): Observable<INDISpecial> {
    return this.http.post<INDISpecial>(this.serviceURL + '/indi', indiSpecial);
  }

  getINDISpecial(id: number): Observable<INDISpecial> {
    return this.http.get<INDISpecial>(`${this.serviceURL}/indi/${id.toString()}`);
  }

  getINDIStats(): Observable<Stats> {
    return this.http.get<Stats>(`${this.serviceURL}/indi/stats`);
  }

  getINDISpecials(): Observable<INDISpecial[]> {
    return this.http.get<INDISpecial[]>(this.serviceURL + '/indi');
  }
}
